/**
 * Route for `iterable-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IterableIntegrationPage } from "../features/iterable-integration/IterableIntegrationPage";

export const iterableIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/iterable-integration",
	component: IterableIntegrationPage,
});

export default iterableIntegrationRoute;
